const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class TradeRoutesAgreement extends Pact {
    constructor() {
        super(
            Age.Age1,
            PactNames.TradeRoutesAgreement,
            "Once per round A can use 1 food instead of 1 resource. Once per round B can use 1 resource instead of 1 food.",
            {}
        )
    }
}

module.exports = TradeRoutesAgreement;